import { contactsGateway } from "@/gateways/contactsGateway";
import type { MutationCallbacks } from "@/types";
import { useMutation } from "@tanstack/vue-query";

export function useConfirmContactPhoneNumber(
  token: string,
  callbacks: MutationCallbacks<void> = {},
) {
  const mutation = useMutation({
    mutationFn: () => contactsGateway.confirmPhoneNumber(token),
    onSuccess: () => {
      if (callbacks.onSuccess) callbacks.onSuccess();
    },
  });

  return {
    ...mutation,
    confirmContactPhoneNumberStatus: mutation.status,
    confirmContactPhoneNumber: mutation.mutate,
  };
}
